import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Field } from "@/components/common";
import BackNav from "@/components/BackNav";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Le due password non coincidono.");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Password aggiornata.");
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-14" data-testid="reset-password-page">
      <div className="mb-6"><BackNav /></div>
      <div className="card-soft p-8">
        {!token ? (
          <div data-testid="reset-invalid">
            <h1 className="font-serif text-3xl text-navy mb-4">Link non valido.</h1>
            <p className="text-sm text-muted-soft">Questo link di reimpostazione non è valido. Contattaci su WhatsApp per riceverne uno nuovo.</p>
          </div>
        ) : done ? (
          <div data-testid="reset-success">
            <h1 className="font-serif text-3xl text-navy mb-4">Password aggiornata.</h1>
            <p className="text-sm text-muted-soft mb-6">La tua nuova password è attiva. Puoi accedere subito.</p>
            <Link to="/accedi" data-testid="reset-goto-login" className="btn-primary inline-block w-full text-center">Vai all'accesso</Link>
          </div>
        ) : (
          <>
            <h1 className="font-serif text-3xl text-navy mb-2">Nuova password.</h1>
            <p className="text-sm text-muted-soft mb-6">Scegli la tua nuova password. Il link è monouso e vale 24 ore.</p>
            <form onSubmit={submit} className="space-y-4">
              <Field label="Nuova password" testid="field-new-password">
                <input data-testid="input-new-password" type="password" className="input-soft" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} />
              </Field>
              <Field label="Conferma password" testid="field-confirm-password">
                <input data-testid="input-confirm-password" type="password" className="input-soft" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={6} />
              </Field>
              {error && <p data-testid="reset-error" className="text-sm text-red-700 bg-red-50 border border-red-100 rounded-xl px-4 py-2.5">{error}</p>}
              <button data-testid="reset-submit" type="submit" disabled={busy} className="btn-primary w-full disabled:opacity-60">
                {busy ? "Un momento…" : "Imposta nuova password"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
